/* ==========================================================================
   Cart Drawer — open/close, qty update, remove, AJAX refresh
   ========================================================================== */

(function () {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  /* --------------------------------------------------------------------------
     1. OPEN / CLOSE
     -------------------------------------------------------------------------- */
  function openDrawer() {
    drawer.classList.add('is-open');
    window.Midastime.openOverlay();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    window.Midastime.closeOverlay();
  }

  window.Midastime.on('cart:toggle', function () {
    if (drawer.classList.contains('is-open')) {
      closeDrawer();
    } else {
      refreshDrawer().then(openDrawer);
    }
  });

  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', closeDrawer);
  });

  window.Midastime.on('overlay:click', function () {
    closeDrawer();
  });

  window.Midastime.on('escape:pressed', function () {
    closeDrawer();
  });

  /* --------------------------------------------------------------------------
     2. REFRESH DRAWER (fetch section HTML)
     -------------------------------------------------------------------------- */
  function refreshDrawer() {
    var sectionId = drawer.closest('[data-section-id]')
      ? drawer.closest('[data-section-id]').getAttribute('data-section-id')
      : 'cart-drawer';

    return fetch('/?sections=' + sectionId, {
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data[sectionId];
        if (!html) return;

        var temp = document.createElement('div');
        temp.innerHTML = html;

        var newBody = temp.querySelector('[data-cart-body]');
        var newFooter = temp.querySelector('.drawer__footer');
        var newCount = temp.querySelector('[data-cart-count]');

        var currentBody = drawer.querySelector('[data-cart-body]');
        var currentFooter = drawer.querySelector('.drawer__footer');

        if (currentBody && newBody) {
          currentBody.innerHTML = newBody.innerHTML;
        }

        if (newFooter) {
          if (currentFooter) {
            currentFooter.innerHTML = newFooter.innerHTML;
          } else {
            drawer.appendChild(newFooter);
          }
        } else if (currentFooter) {
          currentFooter.remove();
        }

        /* Re-bind close buttons */
        drawer.querySelectorAll('[data-cart-close]').forEach(function (btn) {
          btn.addEventListener('click', closeDrawer);
        });

        /* Update all cart counters */
        if (newCount) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            el.textContent = newCount.textContent;
            el.classList.toggle('hidden', newCount.textContent.trim() === '0');
          });
        }
      })
      .catch(function (err) {
        console.error('Cart drawer refresh failed:', err);
      });
  }

  /* --------------------------------------------------------------------------
     3. QTY CHANGE (delegated)
     -------------------------------------------------------------------------- */
  drawer.addEventListener('click', function (e) {
    var btn = e.target.closest('.qty-selector__btn');
    if (!btn) return;

    var lineKey = btn.getAttribute('data-line-key');
    if (!lineKey) return;

    var item = btn.closest('.cart-item');
    var input = item.querySelector('[data-qty-input]');
    var current = parseInt(input.value, 10) || 1;
    var newQty;

    if (btn.hasAttribute('data-action-minus')) {
      newQty = Math.max(0, current - 1);
    } else if (btn.hasAttribute('data-action-plus')) {
      newQty = Math.min(99, current + 1);
    } else {
      return;
    }

    input.value = newQty;
    updateLineItem(lineKey, newQty);
  });

  drawer.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;

    var lineKey = input.getAttribute('data-line-key');
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;

    updateLineItem(lineKey, qty);
  });

  /* --------------------------------------------------------------------------
     4. REMOVE ITEM
     -------------------------------------------------------------------------- */
  drawer.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-remove-item]');
    if (!removeBtn) return;

    var lineKey = removeBtn.getAttribute('data-line-key');
    updateLineItem(lineKey, 0);
  });

  /* --------------------------------------------------------------------------
     5. UPDATE LINE ITEM
     -------------------------------------------------------------------------- */
  function updateLineItem(key, quantity) {
    window.Midastime.cart.change(key, quantity)
      .then(function () {
        return refreshDrawer();
      });
  }

  /* --------------------------------------------------------------------------
     6. UPSELL — HELPERS
     -------------------------------------------------------------------------- */
  function getUpsellVariants(item) {
    var el = item.querySelector('[data-upsell-variants]');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (_) { return []; }
  }

  function findUpsellVariant(variants, colorIdx, colorVal, sizeIdx, sizeVal) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (colorIdx !== null && v.options[colorIdx] !== colorVal) continue;
      if (sizeIdx !== null && v.options[sizeIdx] !== sizeVal) continue;
      return v;
    }
    return null;
  }

  function updateUpsellSizes(modal, variants, colorIdx, colorVal, sizeIdx) {
    if (sizeIdx === null) return;
    modal.querySelectorAll('[data-upsell-size]').forEach(function (btn) {
      var sizeVal = btn.getAttribute('data-size-value');
      var variant = findUpsellVariant(variants, colorIdx, colorVal, sizeIdx, sizeVal);
      var avail = variant && variant.available;
      btn.classList.toggle('upsell-modal__size--unavailable', !avail);
      btn.disabled = !avail;
      if (!avail) btn.setAttribute('aria-disabled', 'true');
      else btn.removeAttribute('aria-disabled');
    });
  }

  function addUpsellToCart(btn, variantId) {
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    window.Midastime.cart.add({ id: variantId, quantity: 1 })
      .then(function () {
        return refreshDrawer();
      });
  }

  /* --------------------------------------------------------------------------
     6a. UPSELL — DIRECT ADD (single variant)
     -------------------------------------------------------------------------- */
  drawer.addEventListener('click', function (e) {
    var upsellBtn = e.target.closest('[data-upsell-add]');
    if (!upsellBtn) return;

    var variantId = upsellBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    upsellBtn.disabled = true;
    upsellBtn.textContent = '...';

    window.Midastime.cart.add({ id: parseInt(variantId, 10), quantity: 1 })
      .then(function () {
        return refreshDrawer();
      });
  });

  /* --------------------------------------------------------------------------
     6b. UPSELL — OPEN MODAL
     -------------------------------------------------------------------------- */
  drawer.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-upsell-modal-toggle]');
    if (!toggleBtn) return;

    var item = toggleBtn.closest('[data-upsell-item]');
    if (!item) return;

    /* Close any other open upsell modal */
    drawer.querySelectorAll('[data-upsell-modal]:not([hidden])').forEach(function (m) {
      m.hidden = true;
      m.querySelectorAll('.is-selected').forEach(function (s) { s.classList.remove('is-selected'); });
    });

    var modal = item.querySelector('[data-upsell-modal]');
    if (!modal) return;

    /* Reset state */
    modal.querySelectorAll('.is-selected').forEach(function (s) { s.classList.remove('is-selected'); });
    var hasColor = modal.getAttribute('data-has-color') === 'true';
    var hasSize = modal.getAttribute('data-has-size') === 'true';
    var sizeIdx = modal.hasAttribute('data-size-index') ? parseInt(modal.getAttribute('data-size-index'), 10) : null;

    if (hasColor && hasSize) {
      modal.querySelectorAll('[data-upsell-size]').forEach(function (b) {
        b.disabled = true;
        b.classList.add('upsell-modal__size--unavailable');
      });
    } else if (hasSize && !hasColor) {
      var variants = getUpsellVariants(item);
      updateUpsellSizes(modal, variants, null, null, sizeIdx);
    }

    modal.hidden = false;
  });

  /* --------------------------------------------------------------------------
     6c. UPSELL — SELECT COLOR
     -------------------------------------------------------------------------- */
  drawer.addEventListener('click', function (e) {
    var colorBtn = e.target.closest('[data-upsell-color]');
    if (!colorBtn) return;

    var modal = colorBtn.closest('[data-upsell-modal]');
    if (!modal) return;
    var item = modal.closest('[data-upsell-item]');
    if (!item) return;

    /* Mark selected */
    modal.querySelectorAll('[data-upsell-color]').forEach(function (b) {
      b.classList.remove('is-selected');
    });
    colorBtn.classList.add('is-selected');

    var colorVal = colorBtn.getAttribute('data-upsell-color');
    var colorIdx = modal.hasAttribute('data-color-index') ? parseInt(modal.getAttribute('data-color-index'), 10) : null;
    var hasSize = modal.getAttribute('data-has-size') === 'true';
    var sizeIdx = modal.hasAttribute('data-size-index') ? parseInt(modal.getAttribute('data-size-index'), 10) : null;
    var variants = getUpsellVariants(item);

    if (hasSize) {
      updateUpsellSizes(modal, variants, colorIdx, colorVal, sizeIdx);
    } else {
      /* Color-only: add to cart immediately */
      var variant = findUpsellVariant(variants, colorIdx, colorVal, null, null);
      if (variant && variant.available) addUpsellToCart(colorBtn, variant.id);
    }
  });

  /* --------------------------------------------------------------------------
     6d. UPSELL — SELECT SIZE → ADD TO CART
     -------------------------------------------------------------------------- */
  drawer.addEventListener('click', function (e) {
    var sizeBtn = e.target.closest('[data-upsell-size]');
    if (!sizeBtn || sizeBtn.disabled) return;

    var modal = sizeBtn.closest('[data-upsell-modal]');
    if (!modal) return;
    var item = modal.closest('[data-upsell-item]');
    if (!item) return;

    var sizeIdx = modal.hasAttribute('data-size-index') ? parseInt(modal.getAttribute('data-size-index'), 10) : null;
    var colorIdx = modal.hasAttribute('data-color-index') ? parseInt(modal.getAttribute('data-color-index'), 10) : null;
    var sizeVal = sizeBtn.getAttribute('data-size-value');
    var variants = getUpsellVariants(item);

    var colorVal = null;
    var hasColor = modal.getAttribute('data-has-color') === 'true';
    if (hasColor) {
      var selectedColor = modal.querySelector('[data-upsell-color].is-selected');
      if (!selectedColor) return;
      colorVal = selectedColor.getAttribute('data-upsell-color');
    }

    var variant = findUpsellVariant(variants, colorIdx, colorVal, sizeIdx, sizeVal);
    if (variant && variant.available) {
      addUpsellToCart(sizeBtn, variant.id);
    }
  });

  /* --------------------------------------------------------------------------
     7. LISTEN FOR cart:updated TO AUTO-REFRESH
     -------------------------------------------------------------------------- */
  window.Midastime.on('cart:updated', function () {
    if (drawer.classList.contains('is-open')) {
      refreshDrawer();
    }
  });

})();
